import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'elevated' | 'outlined' | 'flat';
}

export const Card: React.FC<CardProps> = ({ children, className = '', variant = 'elevated' }) => {
  const variants: Record<string, string> = {
    elevated: 'bg-surface-container-lowest shadow-level1',
    outlined: 'bg-surface outline-variant/15 outline-1 outline',
    flat: 'bg-surface-container-low',
  };

  return (
    <div
      className={`rounded-2xl p-6 transition-all duration-300 ${variants[variant]} ${className}`}
    >
      {children}
    </div>
  );
};
